import * as React from "react";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";

import ConfirmationModal from "../../../../customer/components/ConfirmationModal";
import styles from "../../../../customer/styles/customerStyles.module.css";
import { Icon } from "@iconify/react";
import { useNavigate } from "react-router-dom";
import StoreStatusUpdateModal from "./StoreStatusUpdateModal";

function Row(props) {
  const { row } = props;
  const shouldBold = { fontWeight: "bold" };
  const navigate = useNavigate();

  function getStoreChips(status) {
    if (status === true) {
      return (
        <div
          style={{
            background: "#D4FFD3",
            maxWidth: "100px",
            margin: "auto",
          }}
          className={styles.fulfillment}
        >
          active
        </div>
      );
    } else {
      return (
        <div
          style={{
            background: "#FFCFCF",
            maxWidth: "100px",
            margin: "auto",
          }}
          className={styles.fulfillment}
        >
          inactive
        </div>
      );
    }
  }

  return (
    <React.Fragment>
      <TableRow
        sx={{
          "& > *": { borderBottom: "unset" },
          borderBottom: "1px solid #ebebeb",
          width: "100%",
          "&:hover": {
            backgroundColor: "rgba(244,244,244,.5)",
          },
        }}
      >
        <TableCell sx={shouldBold}>{row?.store_name}</TableCell>
        {/* <TableCell align="center" sx={shouldBold}>
          {row?.users?.length}
        </TableCell> */}
        {/* <TableCell sx={shouldBold}>{row?.payment_method}</TableCell> */}
        {/* <TableCell sx={shouldBold} align="center">
          {row?.users?.filter((user) => user.role === "admin").length}
        </TableCell> */}
        <TableCell sx={shouldBold} align="center">
          {row?.total_orders}
        </TableCell>
        <TableCell sx={shouldBold} align="center">
          {row?.total_disputes}
        </TableCell>
        <TableCell sx={shouldBold} align="center">
          {row?.total_transactions}
        </TableCell>
        <TableCell sx={shouldBold} align="center">
          €{row?.current_balance[0]?.current_balance.toFixed(2) || row?.current_balance?.toFixed(2) || "0"}
        </TableCell>

        <TableCell align="center" sx={shouldBold}>
          {getStoreChips(row?.is_active)}
        </TableCell>
        <TableCell align="right">
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-end",
            }}
          >
            <Icon
              icon="bi:eye"
              width="20"
              height="20"
              style={{ cursor: "pointer", marginTop: "3px" }}
              onClick={() => navigate(`store-details/${row._id}`)}
            />
            <StoreStatusUpdateModal storeId={row?._id} />
            <div style={{ marginTop: "8px" }}>
              <ConfirmationModal
                icon="delete"
                title="Are you sure you want to delete this store?"
                confirm="Delete"
                elementId={{store:row?._id}}
              />
            </div>
          </div>
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
}
export default function StoreDataTable({ stores }) {
  const tableHeadStyles = {
    color: "#707070",
    fontWeight: 500,
  };
  return (
    <TableContainer
      component={Paper}
      sx={{
        marginTop: "20px",
        // padding: "1% ",
        width: "100%",
        boxShadow: "none",
      }}
    >
      <Table aria-label="collapsible table">
        <TableHead>
          <TableRow
            sx={{
              background: "#eeeeee",
            }}
          >
            <TableCell
              sx={{ color: "#707070", fontWeight: 500, paddingLeft: "16px" }}
            >
              Store name
            </TableCell>
            {/* <TableCell
              align="center"
              sx={{ color: "#707070", fontWeight: 500, paddingLeft: "16px" }}
            >
              Users
            </TableCell>
            <TableCell
              align="center"
              sx={{ color: "#707070", fontWeight: 500, paddingLeft: "16px" }}
            >
              Admins
            </TableCell> */}
            <TableCell
              align="center"
              sx={{ color: "#707070", fontWeight: 500, paddingLeft: "16px" }}
            >
              Orders
            </TableCell>
            <TableCell
              align="center"
              sx={{ color: "#707070", fontWeight: 500, paddingLeft: "16px" }}
            >
              Disputes
            </TableCell>
            <TableCell
              align="center"
              sx={{ color: "#707070", fontWeight: 500, paddingLeft: "16px" }}
            >
              Transactions
            </TableCell>
            <TableCell
              align="center"
              sx={{ color: "#707070", fontWeight: 500, paddingLeft: "16px" }}
            >
              Current Account Balance
            </TableCell>
            <TableCell
              align="center"
              sx={{ color: "#707070", fontWeight: 500, paddingLeft: "16px" }}
            >
              Status
            </TableCell>

            <TableCell align="right" sx={tableHeadStyles}>
              Action
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {stores?.map((row) => (
            <Row key={row._id} row={row} />
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
